<app-block-content [blocked]="isLoading"></app-block-content>
<lib-menu-container [menuItems]="menuList$"></lib-menu-container>
